"use client";

import { memo } from "react";
// import './article-custom.scss';

import { appendRequiredBlocksMarkerClient } from "../fields/TiptapEditor/extensions/serverside/useAppendRequiredBlocksMarkerClient.js";
import { ServersideTiptapBody } from "../fields/TiptapEditor/extensions/serverside/ServersideTiptapBody.js";
import { EmbedContentInlineRenderer } from "../fields/TiptapEditor/extensions/serverside/EmbedContentInlineRenderer.js";
import { cn } from "../fields/TiptapEditor/lib/utils/index.js";

const TRT_ARTICLE_BODY_ID = "TRT-ARTICLE-BODY-ID";

type Props = {
  body: any;
  wrapperClassName?: string;
  articleClassName?: string;
  getVideoAspect?: () => void;
};
export const ArticleBody = memo(
  ({
    body,
    wrapperClassName,
    articleClassName,
    getVideoAspect,
  }: Props) => {
    const json = appendRequiredBlocksMarkerClient(body);
    if (!json) return null;
    return (
      <div
        className={cn(
          "text-grey-12 lg:grid trt-article-body-wrapper trt-article-page-wrapper w-full",
          wrapperClassName
        )}
      >
        <div />
        <div id={TRT_ARTICLE_BODY_ID} className="w-full flex flex-col">
          <div
            className={cn(
              "!selection:text-purple-900 font-notosans lg:text-xl lg:leading-8 md:text-lg md:leading-[30px] text-base",
              articleClassName
            )}
          >
            <ServersideTiptapBody body={json} />
          </div>
        </div>
        <EmbedContentInlineRenderer
          body={json}
          getVideoAspect={getVideoAspect}
          prefix={TRT_ARTICLE_BODY_ID}
        />
      </div>
    );
  },
  (prev, next) => prev.body?.content?.length === next.body?.content?.length
);
